import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";

@autoinject
@transient()
export class UscgCloseOutDialog {

    constructor(private dialogClientService: DialogClientService,
        private manageVessel: ManageVesselService, private notificationService: NotificationClientService) {

    }

    activityId: number;
    isLod: boolean;
    comments: string;

    reload: () => void;
    protected activate(modelX: any) {
        const model = modelX.item;
        this.reload = modelX.reload;
        this.isLod = 'vesselLODActivityId' in model;
        this.activityId = this.isLod ? model.vesselLODActivityId : model.vesselCOTPActivityId;
    }

    public save() {
        return new Promise<void>((resolve, reject) => {

            this.manageVessel.markUscgItemAsClosed(this.activityId, this.isLod, this.comments)
                .then(() => {
                    this.cancel();
                    if(this.reload){
                        this.reload();
                    }
                    resolve();
                })
                .catch(() => {
                    this.notificationService.show("Error", "Error closing out activity", NotificationType.Error);
                    reject();
                }
                );
        });
    }

    cancel() {
        this.dialogClientService.hide();
    }
}